import { QualityControlWorkOrder } from './work-order-qc.ts';
import { SchedulerSubWorkOrder } from '../../scheduler/models/sub-work-order';

export class QualityControlSubWorkOrder extends SchedulerSubWorkOrder {
  workOrder: QualityControlWorkOrder;

  get quantityToDo(): number {
    return this.workOrder.quantityToDo;
  }

  get quantityRequired(): number {
    return this.workOrder.quantityRequired;
  }
  get quantityBuilt(): number {
    return this.workOrder.quantityBuilt;
  }
  set quantityBuilt(value: number) {
    this.workOrder.quantityBuilt = value;
  }

  get builtReport(): number {
    return this.workOrder.builtReport;
  }
  set builtReport(value: number) {
    this.workOrder.builtReport = value;
  }

  get transactionNumber(): string {
    return this.workOrder.transactionNumber;
  }

  get assemblyTitle(): string {
    return this.workOrder.assemblyItem.title;
  }
  get endDate(): Date {
    return this.workOrder.endDate;
  }

  get producedPlusOnValidation(): number {
    return this.workOrder.producedPlusOnValidation;
  }

  get assemblyType(): string {
    return this.workOrder.assemblyType;
  }

  static fromObject(obj: SchedulerSubWorkOrder): QualityControlSubWorkOrder {
    const newObj = new QualityControlSubWorkOrder();
    const workOrder = QualityControlWorkOrder.fromObject(obj.workOrder);
    Object.assign(newObj, obj);
    newObj.workOrder = workOrder;
    return newObj;
  }
  static transformToWorkOrder(
    obj: SchedulerSubWorkOrder
  ): QualityControlWorkOrder {
    const item = new QualityControlSubWorkOrder();
    Object.assign(item, obj);
    item.workOrder = new QualityControlWorkOrder();
    Object.assign(item.workOrder, obj.workOrder);
    item.workOrder.subWorkOrders = [item];
    item.workOrder.qcSubWorkOrder = item;
    return item.workOrder;
  }
}
